export const buildProvenance = { "commitHash": "a30e79e28faf5bc75f1ff9f17554d8b56e3ca3fe", "branchName": "refs/heads/release/2023.3", "buildDate": "2023-10-12T23:05:00.049Z", "version": "2023.3.13094" };
